
import { useState } from 'react';
import AnimatedText from '../../../components/base/AnimatedText';

const systemData = [
  {
    title: '営業時間',
    items: [
      '営業時間: 20:00 - 25:00',
      '定休日: 毎月1日、水曜、土曜',
      '受付は6階にて承ります'
    ]
  },
  {
    title: '初回料金',
    items: [
      'メインフロア: 60分 1,000円',
      '飲み飲ませ放題',
      '※缶もの、焼酎、ソフトドリンク',
      '3ヶ月以上未来店で再度初回料金適用'
    ]
  },
  {
    title: '基本料金',
    items: [
      'SET: 60分 3,000円',
      'フリータイム: 5,000円',
      '指名料・同伴料: 無料',
      'TAX: 30%'
    ]
  }
];

export default function SystemSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % systemData.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + systemData.length) % systemData.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section id="system" className="py-20 bg-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <AnimatedText
            text="料金システム"
            className="text-4xl font-bold text-white mb-4"
          />
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <AnimatedText
            text="明確で分かりやすい料金体系でご案内いたします"
            className="text-xl text-gray-300"
            delay={300}
          />
        </div>

        {/* Desktop View - Grid */}
        <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {systemData.map((system, index) => (
            <div key={index} className="bg-black/80 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-white mb-3">{system.title}</h3>
                <div className="w-12 h-0.5 bg-blue-500 mx-auto"></div>
              </div>
              
              <ul className="space-y-3">
                {system.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="text-gray-300 text-sm leading-relaxed">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Mobile View - Carousel */}
        <div className="md:hidden relative mb-16">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-300 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {systemData.map((system, index) => (
                <div key={index} className="w-full flex-shrink-0 px-4">
                  <div className="bg-black/80 rounded-lg p-6 border border-gray-700">
                    <div className="text-center mb-6">
                      <h3 className="text-xl font-bold text-white mb-3">{system.title}</h3>
                      <div className="w-12 h-0.5 bg-blue-500 mx-auto"></div>
                    </div>
                    
                    <ul className="space-y-3">
                      {system.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="text-gray-300 text-sm leading-relaxed">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 w-10 h-10 bg-blue-500 hover:bg-blue-600 rounded-full flex items-center justify-center text-white transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 w-10 h-10 bg-blue-500 hover:bg-blue-600 rounded-full flex items-center justify-center text-white transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-6 space-x-2">
            {systemData.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-200 cursor-pointer ${
                  currentSlide === index ? 'bg-blue-500' : 'bg-gray-600 hover:bg-gray-500'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div className="text-center">
          <div className="bg-black/80 rounded-lg p-6 border border-gray-700 max-w-md mx-auto">
            <h3 className="text-xl font-bold text-white mb-3">ご予約・お問い合わせ</h3>
            <p className="text-gray-300 mb-4 text-sm">
              お気軽にお電話にてお問い合わせください
            </p>
            <div className="flex items-center justify-center">
              <i className="ri-phone-line text-blue-500 text-lg mr-2"></i>
              <span className="text-white text-lg font-semibold">078-954-6898</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
